import { FC } from 'react';
import BackNextButtons from 'components/BackNextButtons';
import W8ben from 'components/forms/TaxForm/W8ben';
import values from 'stores/values';
import { CustomerInfoType } from 'types/customer';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

/**
 *  非SSN开户流程 - w8表格页面
 */
const W8: FC<ProgressFormProps> = ({ onSubmit, $formutil }) => {
    const storageInfo = values.getParams<CustomerInfoType>();
    const { has_delivery_address, same_delivery_and_residence } = storageInfo;
    const taxFormCustomerInfo = Object.assign(storageInfo, $formutil.$params);
    // 四个中国选择未勾选有美国邮寄地址时，默认使用居住地址字段
    // 其它国家未勾选邮寄地址与居住地址不一致时，默认使用居住地址字段
    const useHomeAddress = has_delivery_address === false || same_delivery_and_residence === '1';

    const handleSubmit = (ev: React.FormEvent) => {
        onSubmit('../agreements', ev);
    };

    return (
        <form className="open-w8-root" noValidate onSubmit={handleSubmit}>
            <h3 className="open-title my-3">W-8BEN FORM</h3>
            {/* 已勾选无美国邮寄地址时 或者 未勾选邮寄地址与居住地址不一致，则默认使用居住地址字段 */}
            <W8ben customerInfo={taxFormCustomerInfo} useHomeAddress={useHomeAddress} />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    id: 'w8',
    basePath: 'open',
    showProgressBar: false,
    eventParams: {
        exposureEventParams: {
            model: '开户-W8',
            name: 'W8-页面曝光'
        },
        submitEventParams: {
            model: '开户-W8',
            name: 'W8-点击下一步'
        }
    }
})(W8);
